import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Candidacy from './Candidacy/Candidacy'
import PositionFields from './PositionFields/PositionFields'
import PositionHeader from './PositionHeader/PositionHeader'
import RunModal from './RunModal/RunModal'

import positionContainer from './positionContainer'
import './Position.css'

const hideIncumbents = process.env.REACT_APP_HIDE_INCUMBENTS === '1'

// Converts a date string '2018-03-19' to an integer 20180319 for simple
// date comparison
const dateToInt = d => parseInt(d.replace(/[-]/g, ''), 10)

export const Position = ({
  isAuthorized,
  position,
  runButtonVisible,
  standalone
}) => {
  if (!position) {
    return null
  }

  const positionClassNames = classNames('Position', {
    'col': standalone,
    'col-md-8': !standalone,
  })

  const activeParties = process.env.REACT_APP_PARTY_FILTER.split(',').filter(p => p)
  let candidacies = []
  if (position.candidates) {
    candidacies = position.candidates
      .filter(candidate => {
        let result = activeParties.length === 0 || activeParties.includes(candidate.party_name)

        const today = new Date()
        const todayInt = dateToInt(today.toISOString().slice(0,10))

        // Only candidates for upcoming elections
        if (candidate.election_day && dateToInt(candidate.election_day) <= todayInt) {
          result = false
        }

        if (hideIncumbents) {
          result = result && !candidate.incumbent
        }

        return result
      })
      .sort((a, b) => {
        const countA = a.endorsements.length
        const countB = b.endorsements.length

        if (countA > countB) {
          return -1
        }

        if (countA < countB) {
          return 1
        }

        return 0
      })
      .map((candidate, key) =>
        <Candidacy candidate={candidate} key={key} position={position} />
      )
  }

  const hasIncumbent = !!position.candidates.find(c => c.incumbent)

  return (
    <div className={positionClassNames}>
      <PositionHeader
        filled={candidacies.length > 0}
        incumbent={hideIncumbents && hasIncumbent}
        position={position}
        runButtonVisible={runButtonVisible}
      />

      {position && position.has_unknown_boundaries && <div className="alert alert-primary mt-3" role="alert">
        Because precise position-matching data is not available, you may or may not be eligible to run in this district. Contact your local election office to confirm.
      </div>}

      {candidacies.length > 0 ? (
        <div className="Candidacies">{candidacies}</div>
      ) : (
        <PositionFields
          isAuthorized={isAuthorized}
          position={position}
          standalone={standalone}
        />
      )}

      <RunModal />
    </div>
  )
}

Position.propTypes = {
  runButtonVisible: PropTypes.bool,
  standalone: PropTypes.bool,
}

Position.defaultProps = {
  runButtonVisible: true,
  standalone: false,
}

export default positionContainer(Position)



// WEBPACK FOOTER //
// ./src/components/Position/Position.js